import { getOrg } from "utils/site";
import AnimalAccess from "./components/AnimalAccess";
import AnimalBirthday from "./components/AnimalBirthday";
import AnimalBreed from "./components/AnimalBreed";
import AnimalCastrated from "./components/AnimalCastrated";
import AnimalMixedBreed from "./components/AnimalMixedBreed";
import AnimalName from "./components/AnimalName";
import AnimalSex from "./components/AnimalSex";
import AnimalSpecies from "./components/AnimalSpecies";
import HealthQuestionsFra from "./components/fra/HealthQuestions";
import Payment from "./components/Payment";
import QuotePreviewFra from "./components/fra/QuotePreview";
import ThankYouFra from "./components/fra/ThankYou";
import UserEmail from "./components/fra/UserEmail";
import UserInfoFra from "./components/fra/UserInfo";
import UserZipAlgolia from "./components/UserZipAlgolia";
import HealthQuestionsGer from "./components/ger/HealthQuestions";
import LiabilityCancelledPreviouslyQuestion from "./components/ger/LiabilityCancelledPreviouslyQuestion";
import LiabilityPreviousClaimsQuestion from "./components/ger/LiabilityPreviousClaimsQuestion";
import LiabilityQuotePreview from "./components/ger/LiabilityQuotePreview";
import Product from "./components/ger/Product";
import QuotePreviewGer from "./components/ger/QuotePreview";
import ThankYouGer from "./components/ger/ThankYou";
import UserBirthdate from "./components/ger/UserBirthdate";
import UserInfoGer from "./components/ger/UserInfo";
import Loading from "./components/Loading";
import HealthOverview from "./components/swe/HealthOverview";
import HealthQuestionsSwe from "./components/swe/HealthQuestions";
import NewOrSwitch from "./components/swe/NewOrSwitch";
import ThankYouSwe from "./components/swe/ThankYou";
import UserInfoSwe from "./components/swe/UserInfo";
import { stepsFra } from "./fra";
import { stepsGer } from "./ger";
import { stepsSwe } from "./swe";
import { Step } from "./types";
import UserZipSwe from "./components/swe/UserZip";
import FetchCurrentInsurance from "./components/swe/FetchCurrentInsurance";
import ChooseAnimal from "./components/swe/ChooseAnimal";
import FetchCurrentInsuranceQuestion from "./components/swe/FetchCurrentInsuranceQuestion";
import CancelPreviousInsurance from "./components/swe/CancelPreviousInsurance";
import PowerOfAttorney from "./components/swe/PowerOfAttorney";
import QuotePreviewSwe from "./components/swe/QuotePreview";
import Summary from "./components/Summary";
import DraftSummary from "./components/DraftSummary";
import SummaryMultipet from "./components/SummaryMultipet";
import DraftSummaryMultipet from "./components/DraftSummaryMultipet";
import Preventive from "./components/fra/Preventive";
import Addons from "./components/swe/Addons";

export const stepMap = {
  species: AnimalSpecies,
  name: AnimalName,
  breed: AnimalBreed,
  "mixed-breed": AnimalMixedBreed,
  "animal-sex": AnimalSex,
  castration: AnimalCastrated,
  "animal-access": AnimalAccess,
  "animal-birthday": AnimalBirthday,
  address: {
    fra: UserZipAlgolia,
    ger: UserZipAlgolia,
    swe: UserZipSwe,
  },
  email: UserEmail,
  loading: Loading,
  "quote-preview": {
    fra: QuotePreviewFra,
    ger: QuotePreviewGer,
    swe: QuotePreviewSwe,
  },
  preventive: Preventive,
  "health-questions": {
    fra: HealthQuestionsFra,
    ger: HealthQuestionsGer,
    swe: HealthQuestionsSwe,
  },
  "user-info": {
    fra: UserInfoFra,
    ger: UserInfoGer,
    swe: UserInfoSwe,
  },
  payment: Payment,
  "thank-you": {
    fra: ThankYouFra,
    ger: ThankYouGer,
    swe: ThankYouSwe,
  },
  product: Product,
  "user-birthday": UserBirthdate,
  "liability-quote-preview": LiabilityQuotePreview,
  "previous-claims": LiabilityPreviousClaimsQuestion,
  "cancelled-previously": LiabilityCancelledPreviouslyQuestion,
  "health-overview": HealthOverview,
  "new-or-switch": NewOrSwitch,
  "fetch-current-insurance-question": FetchCurrentInsuranceQuestion,
  "fetch-current-insurance": FetchCurrentInsurance,
  "choose-animal": ChooseAnimal,
  "cancel-previous-insurance": CancelPreviousInsurance,
  "power-of-attorney": PowerOfAttorney,
  summary: SummaryMultipet,
  "draft-summary": DraftSummaryMultipet,
  "summary-liability": Summary,
  "draft-summary-liability": DraftSummary,
  "summary-flytthjalp": Summary,
  "draft-summary-flytthjalp": DraftSummary,
  "add-ons": Addons,
};

export const getSteps = (): Step[] => {
  const org = getOrg();

  switch (org) {
    case "fra":
      return stepsFra;
    case "ger":
      return stepsGer;
    case "swe":
      return stepsSwe;

    default:
      throw new Error(`Could not get steps for ${org}`);
  }
};
